<template>
    <div>
        <card-header title="Enrollment Options" icon="fa-sliders"></card-header>

        <card-toolbar>
            <button @click="$openCard('course-new-config', {courseId: course.id}, card)"><i class="far fa-plus"></i>New Enrollment Option</button>
        </card-toolbar>

        <card-body>
            <card-list>

                <draggable v-model="course.configs" handle=".handle" @change="updateOrder">
                    <transition-group>
                        <course-config-tile
                            :card="card"
                            :config="config"
                            v-for="config in course.configs"
                            @click="$openCard('course-edit-config', {courseId: props.courseId, configId: config.id}, card)"
                            :active="(child && child.definition.component === 'course-edit-config' && config.id === parseInt(child.props.configId))"
                            class="t-card-list-item"
                            :key="config.id"
                        />
                    </transition-group>
                </draggable>

                <container-list-item v-if="!course.configs || course.configs.length === 0" padded>
                    <p class="has-text-grey">No enrollment options configured. Click "New Enrollment Option" to create one.</p>
                </container-list-item>

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    import {client as http} from '@/http_client';
    import CourseConfigTile from "../../../components/tiles/CourseConfigTile";

    import draggable from 'vuedraggable';

    export default {
        components: {CourseConfigTile, ContainerListItem, CardToolbar, CardList, CardHeader, CardBody, draggable},
        props: ['card', 'props', 'child'],
        data() {
            return {
                course: {
                    configs: []
                }
            };
        },
        methods: {
            loadConfigs: function (force) {
                this.$emit('loading', true);
                http.get('courses/' + this.props.courseId + '/configs', {force}).then(response => {
                    this.course.id = this.props.courseId;
                    this.course.configs = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.log(err);
                    this.$emit('loading', false);
                });
            },
            updateOrder: function () {
                let order = [];
                for (let i = 0; i < this.course.configs.length; i++) {
                    order.push(this.course.configs[i].id)
                }
                http.post('courses/' + this.props.courseId + '/configs/order', {order}).then(response => {

                }).catch(err => {
                    console.log(err);
                });
            },
            reload: function () {
                this.loadConfigs(true);
            }
        },
        mounted() {
            this.loadConfigs();
        }
    }
</script>

<style>

</style>
